import { PageGroup } from '@sleepstation/components'
import { CopyRenderer } from '@sleepstation/components-markdown-renderer'
import { parseToAst } from '@sleepstation/markdown'
import {
  backgroundImageLinearGradient,
  mq,
  paddingBottom,
  paddingTop,
  stylesIfElseProp,
} from '@sleepstation/style-api-helpers'
import { constrainWide } from '@sleepstation/style-mixins'
import PropTypes from 'prop-types'
import React from 'react'
import styled, { css } from 'styled-components'
import Border from '../../Border'

// -----------------------------------------------------------------------------
// Sub-components
// -----------------------------------------------------------------------------

const Wrapper = styled.div.attrs({
  className: `Breakout`,
})`
  position: relative;
  ${paddingTop([1, 3, 3])}

  ${stylesIfElseProp(
    `hasGradient`,
    css`
      ${backgroundImageLinearGradient()}
      ${paddingBottom([2, 4, 5])}
    `,
    css`
      ${paddingBottom([2, 2, 3])}
    `
  )}
`

const Layout = styled.div`
  ${constrainWide()}

  ${mq(`mediumUp`)} {
    > * {
      max-width: 65.1%;
    }
  }
`

// -----------------------------------------------------------------------------
// Component
// -----------------------------------------------------------------------------

const LeftAlignedSimpleHeroAlt = ({ title, body, hasBorder }) => {
  const bodyAst = parseToAst(body)
  return (
    <Wrapper hasGradient={hasBorder}>
      <Layout>
        <PageGroup title={title} spacing={[0.5, 1]}>
          <CopyRenderer htmlAst={bodyAst} />
        </PageGroup>
      </Layout>
      {hasBorder && (
        <Border color="backgroundStart" kind="inset" edge="bottom" />
      )}
    </Wrapper>
  )
}

LeftAlignedSimpleHeroAlt.propTypes = {
  title: PropTypes.string.isRequired,
  body: PropTypes.string.isRequired,
  hasBorder: PropTypes.bool,
}

LeftAlignedSimpleHeroAlt.defaultProps = {
  hasBorder: false,
}

export default LeftAlignedSimpleHeroAlt
